export let activities = [
  {
    id: 1,
    name: "Copacabana Beach",
    price_adult: 60,
    price_child: 30,
    time: "12h",
    free_cancellation: 1,
    electric_voucher: 1,
    sub_name: "English Commentary Tour",
    thumb: "assets/img/trip/thumb/trip_1.jpg",
    description: "From sexy Ipanema and Copacabana, to more secluded and slightly lesser-known stretches of sand, like Prainha Beach, Brazil's Rio de Janeiro is best known for its beaches. Grab your sunscreen and Brazilian bikinis and head to the sunny shores of Rio's best beaches.",
    location: "Rio de Janeiro, Brazil",
    images: [
      "assets/img/trip/thumb/trip_1.jpg",
      "assets/img/trip/thumb/trip_6.jpg",
      "assets/img/trip/thumb/trip_7.jpg",
      "assets/img/trip/thumb/trip_8.jpg",
    ],
    highlights: [
      "Numerous kiosks",
      "First in a string of Atlantic Ocean-facing beaches",
      "Sand is flanked by mountains in the background",
      "Swing in the turquoise waters",
      "Water Sports",
    ]
  },
  {
    id: 2,
    name: "Christ the Redeemer",
    price_adult: 90,
    price_child: 45,
    time: "4h",
    free_cancellation: 1,
    electric_voucher: 1,
    sub_name: "English Commentary Tour",
    thumb: "assets/img/trip/thumb/trip_2.jpg",
    description: "From sexy Ipanema and Copacabana, to more secluded and slightly lesser-known stretches of sand, like Prainha Beach, Brazil's Rio de Janeiro is best known for its beaches. Grab your sunscreen and Brazilian bikinis and head to the sunny shores of Rio's best beaches.",
    location: "Rio de Janeiro, Brazil",
    images: [
      "assets/img/trip/thumb/trip_2.jpg",
      "assets/img/trip/thumb/trip_6.jpg",
      "assets/img/trip/thumb/trip_7.jpg",
      "assets/img/trip/thumb/trip_8.jpg",
    ],
    highlights: [
      "Numerous kiosks",
      "First in a string of Atlantic Ocean-facing beaches",
      "Sand is flanked by mountains in the background",
      "Swing in the turquoise waters",
      "Water Sports",
    ]
  },
  {
    id: 3,
    name: "Ipiranga Museum",
    price_adult: 30,
    price_child: 15,
    time: "6h",
    free_cancellation: 1,
    electric_voucher: 1,
    sub_name: "English Commentary Tour",
    thumb: "assets/img/trip/thumb/trip_3.jpg",
    description: "From sexy Ipanema and Copacabana, to more secluded and slightly lesser-known stretches of sand, like Prainha Beach, Brazil's Rio de Janeiro is best known for its beaches. Grab your sunscreen and Brazilian bikinis and head to the sunny shores of Rio's best beaches.",
    location: "São Paulo, Brazil",
    images: [
      "assets/img/trip/thumb/trip_3.jpg",
      "assets/img/trip/thumb/trip_6.jpg",
      "assets/img/trip/thumb/trip_7.jpg",
      "assets/img/trip/thumb/trip_8.jpg",
    ],
    highlights: [
      "Numerous kiosks",
      "First in a string of Atlantic Ocean-facing beaches",
      "Sand is flanked by mountains in the background",
      "Swing in the turquoise waters",
      "Water Sports",
    ]
  },
  {
    id: 4,
    name: "Fernando de Noronha",
    price_adult: 500,
    price_child: 250,
    time: "24h",
    free_cancellation: 1,
    electric_voucher: 1,
    sub_name: "English Commentary Tour",
    thumb: "assets/img/trip/thumb/trip_4.jpg",
    description: "From sexy Ipanema and Copacabana, to more secluded and slightly lesser-known stretches of sand, like Prainha Beach, Brazil's Rio de Janeiro is best known for its beaches. Grab your sunscreen and Brazilian bikinis and head to the sunny shores of Rio's best beaches.",
    location: "Fernando de Noronha, Brazil",
    images: [
      "assets/img/trip/thumb/trip_4.jpg",
      "assets/img/trip/thumb/trip_6.jpg",
      "assets/img/trip/thumb/trip_7.jpg",
      "assets/img/trip/thumb/trip_8.jpg",
    ],
    highlights: [
      "Numerous kiosks",
      "First in a string of Atlantic Ocean-facing beaches",
      "Sand is flanked by mountains in the background",
      "Swing in the turquoise waters",
      "Water Sports",
    ]
  }
]
